import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { QueueName, QueuePages } from '@core/services/work-queue/work-queue.model';
import { WorkQueueService } from '@core/services/work-queue/work-queue.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'Teranet-WorkQueue',
  templateUrl: './work-queue.component.html'
})
export class WorkQueueComponent implements OnInit {
  clientInfoId: number;
  fromAccountViewQueueType: string = '';
  queuePages: QueuePages[];
  selectedIndex: number;

  @ViewChild('mattab', { static: false }) mattab: MatTabGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private workQueueService: WorkQueueService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.clientInfoId = this.localStorageService.getItem('currentUser')
        ? this.localStorageService.getItem('currentUser').corporationid >= 0
          ? this.localStorageService.getItem('currentUser').corporationid
          : -1
        : -1;
      if (this.clientInfoId == -1) {
        this.toastrService.error('There is problem with your login, please logout and try again.');
        return;
      }
      this.selectedIndex = 0;
      if (params['from'] == 'accountview' || params['from'] == 'main') {
        if (params['queuetype'] == 1) this.fromAccountViewQueueType = 'LenderRemediation';
        if (params['queuetype'] == 2) this.fromAccountViewQueueType = 'LenderReconciliation';
        if (params['queuetype'] == 3) this.fromAccountViewQueueType = 'Watchlist';
        //this.fromAccountViewQueueType = params['queuetype'];
      }
      this.refresh();
    });
  }

  isShowTab(queueName: string): boolean {
    if (this.queuePages != null && this.queuePages.length > 0) {
      if (this.queuePages.some(q => q.displayName === queueName)) {
        return true;
      }
    }
    return false;
  }

  isSelectedtab(selectedIndex: number, queueName: string): boolean {
    return selectedIndex === this.queuePages.findIndex(q => q.displayName === queueName);
  }

  refresh() {
    this.workQueueService.GetQueuePages().subscribe(data => {
      this.queuePages = data as QueuePages[];
      if (this.fromAccountViewQueueType && this.fromAccountViewQueueType.length > 0) {
        this.selectedIndex = this.queuePages.findIndex(
          q => q.displayName === QueueName[this.fromAccountViewQueueType]
        );
      }
    });
  }

  public get queueName(): typeof QueueName {
    return QueueName;
  }
}
